import React, { useContext, useEffect, useRef, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext';
import SimpleTable from '../helper/SimpleTable';
import Loading from '../helper/Loading';
import axios from 'axios';
import moment from 'moment';
import UserInfoDisplay from '../helper/UserInfoDisplay';
import { withTranslation } from 'react-i18next';



const ViewQuiz = props => {
    const history = useHistory()
    const userMain = useContext(authContext)
    const roles = userMain.roles
    const params = useParams()

    const mounted = useRef(true)

    const {t} = props;

    const tableCells = [
        { id: 'score', label: t('ViewQuiz.Score'), centered: false },
        { id: 'startDate', label: t('ViewQuiz.Started'), centered: false },
        { id: 'endDate', label: t('ViewQuiz.Finished'), centered: false },
        { id: 'STATUS', label: t('ViewQuiz.Status'), centered: false },

    ];

    const state = history.location.state
    const [data, setData] = useState(null) // the session history for the table
    const [userData, setUserData] = useState({ DOB: null, email: null, first_name: null, last_name: null, username: null }) // user account info from the get request, could have used authContext, but admin and employer will not be able to use it, so I just made dashboard also use the same get request
    const [max, setMax] = useState("")

    // looks for the admin role
    const enableActions = roles.isUserAdmin === 1 ? true : false
    const disableActions = state && state.certTest && !enableActions
    const restricted = state.restricted ? true : false

    // if from admin, use the state username, otherwise use authcontect username
    //const username = (props.from==="admin" && state) ? state.username : user.username
    const username = state.username

    async function getData() {

        // if the username is defined (coming from admin), otherwise grab the current user's username
        console.log(username);
        console.log(params.id);
        console.log(state.trainingId);
        const res = await axios.all([
            axios.get('/api/test/all', {
                params: {
                    student_id: username,
                    courseId: params.id,
                    trainingId: state.trainingId
                }
            }),
            axios.get('/api/user/info/' + username)

        ])
        const testData = res[0].data.tests.map(e => {

            e.actionsDisabled = {
                showDisregard: enableActions && state && state.certTest && e.isDisregarded !== true,
                showUndisregard: enableActions && state && state.certTest && e.isDisregarded === true,
                showView: enableActions
            }

            // fomatting the time with this causes issues if the millisecond time is larger than a day (wraps back around to the next day, max of 23:59:59)
            // e.humanTime = moment.utc(e.TOTALTIMEINMILLISECOND).format('HH:mm:ss')
            if (e.startDate !== null && e.startDate !== undefined) e.startDate = moment(e.startDate).format('YYYY-MM-DD hh:mm:ss A')
            if (e.endDate !== null && e.endDate !== undefined) e.endDate = moment(e.endDate).format('YYYY-MM-DD hh:mm:ss A')
            // since  the susend data is only saved if status is passed (because status is not part of model? so can't use status directly)
            //e.STATUS = e.scormSuspendData ?  "Passed" : e.isDisregarded ? "Disregarded" : null
            e.STATUS =  e.isDisregarded ? t('trainingStatus.Status_Discarded') : e.status ? t('trainingStatus.Status', { context: e.status }) : null
            return e
        })

        const maxScore = Math.max(...testData.map(e => e.score))
        console.log(testData, maxScore)

        if (mounted.current) {
            setData(testData)
            setMax(maxScore)
            setUserData(res[1].data.user)

        }
    }
    useEffect(() => {
        getData()

        return () => mounted.current = false
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onDisregard = async (id) => {
        console.log("disregard clicked")
         const token = userMain.accessToken
            
        const res = await axios.post('/api/test/setDisregarded/' + id, 
            {
                disregarded: true
            }, {
            headers: {
                Authorization: token
            }
        })
        if (res.status === 200) {
            getData()
            
        }
    }

    const onUndisregard = async (id) => {
        console.log("disregard clicked")
         const token = userMain.accessToken
            
        const res = await axios.post('/api/test/setDisregarded/' + id, 
            {
                disregarded: false
            }, {
            headers: {
                Authorization: token
            }
        })
        if (res.status === 200) {
            getData()
            
        }
    }

    const onShow = (id) => {
        history.push('/administration/quiz/questions/' + id)
    }

    const actionButtons = [
        { icon: "view", action: onShow, delete: false, view: "showView", label: t('ViewQuiz.View') },
        { icon: "disregard", action: onDisregard, delete: false, view: "showDisregard", label: t('ViewQuiz.Disregard') }, // undisregard shows if admin
        { icon: "undisregard", action: onUndisregard, delete: false, view: "showUndisregard", label: t('ViewQuiz.Undisregard') }, // disregard shows if admin
    ];

    return (
        <>
            <PageHeader title={state ? t('ViewQuiz.QuizHistory') + state.label + "'" : t('ViewQuiz.QuizHistoryCourse')  + params.id} cancel={history.goBack} />
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>{t('ViewQuiz.NoDataCourseID')} {params.id}</h1> :
                    <>
                        <UserInfoDisplay userData={userData}  restricted={restricted} />
                        <br />


                        <p> {t('ViewQuiz.NumberOfSessions')} {data.length}</p>
                        <p> {t('ViewQuiz.MaxScore')} {max}</p>
                        <SimpleTable
                            data={data}
                            cellKey={"ID"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={!disableActions} // only admin can see disregard, all users can see detail // old version: buttons enabled if the admin role is found in user account data
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(ViewQuiz);